import React from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { Card } from "antd";

function formatMillions(value) {
  if (value >= 1_000_000) {
    return `$${(value / 1_000_000).toFixed(1)}M`;
  }
  return `$${value.toLocaleString()}`;
}

const CartransfersChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <Card style={{ marginTop: 24 }}>No hay datos</Card>;
  }

  // Transformar los datos al formato que espera recharts
  const chartData = data.map((d) => ({
    time: `${d._id.day}/${d._id.month}/${d._id.year}`,
    totalVentas: d.totalPrice,
    totalImpuestos: d.totalTax,
    transferencias: d.count,
  }));

  // Solo forzar ancho grande cuando hay muchos días (scroll); para pocos días llenar el contenedor
  const chartWidth = chartData.length > 15 ? chartData.length * 70 : null;

  return (
    <div className="modern-charts-container">
      {/* Gráfico principal - Evolución temporal */}
      <div className="main-chart-section">
        <div className="chart-header">
          <div className="chart-title-section">
            <h3 className="chart-main-title">Evolución Temporal</h3>
            <p className="chart-subtitle">
              Transferencias y ventas por día · Desliza ↔ para ver todos los días
            </p>
          </div>
        </div>
        <div className="chart-content">
          <div className="chart-scroll-wrapper">
            <div
              className="chart-scroll-inner"
              style={chartWidth ? { minWidth: chartWidth } : {}}
            >
              <ResponsiveContainer width="100%" height={300}>
                <ComposedChart
                  data={chartData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
                  <XAxis 
                    dataKey="time" 
                    tick={{ fontSize: 12, fill: '#666' }} 
                    height={40}
                    axisLine={{ stroke: '#e8e8e8' }}
                    tickLine={{ stroke: '#e8e8e8' }}
                  />
                  <YAxis
                    yAxisId="left"
                    orientation="left"
                    tickFormatter={formatMillions}
                    width={80}
                    tick={{ fontSize: 12, fill: '#666' }}
                    axisLine={{ stroke: '#e8e8e8' }}
                    tickLine={{ stroke: '#e8e8e8' }}
                  />
                  <YAxis
                    yAxisId="right"
                    orientation="right"
                    allowDecimals={false}
                    width={40}
                    tick={{ fontSize: 12, fill: '#666' }}
                    axisLine={{ stroke: '#e8e8e8' }}
                    tickLine={{ stroke: '#e8e8e8' }}
                  />
                  <Tooltip
                    contentStyle={{
                      backgroundColor: 'white',
                      border: '1px solid #e8e8e8',
                      borderRadius: '12px',
                      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
                    }}
                    formatter={(value, name) => {
                      if (name === "Total ventas" || name === "Total Impuestos") {
                        return [formatMillions(value), name];
                      }
                      if (name === "Transferencias") {
                        return [value, name];
                      }
                      return [value, name];
                    }}
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="totalVentas"
                    name="Total ventas"
                    fill="#1890ff"
                    barSize={20}
                    radius={[4, 4, 0, 0]}
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="totalImpuestos"
                    name="Total Impuestos"
                    fill="#52c41a"
                    barSize={12}
                    radius={[4, 4, 0, 0]}
                  />
                  <Line
                    yAxisId="right"
                    type="monotone"
                    dataKey="transferencias"
                    name="Transferencias"
                    stroke="#fa8c16"
                    strokeWidth={3}
                    dot={{ r: 4, fill: '#fa8c16', stroke: 'white', strokeWidth: 2 }}
                    activeDot={{ r: 6, fill: '#fa8c16', stroke: 'white', strokeWidth: 2 }}
                  />
                </ComposedChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartransfersChart;
